/* eslint no-console: "off", quotes: "off" */
import { mapState, mapMutations } from "vuex";

export const ParseResponseMixin = {
  methods: {
    parseServerResponse(responseBody) {
      let parsedResponse = null;
      try {
        console.log('Parsing server response...');
        parsedResponse = JSON.parse(responseBody);
      } catch (error) {
        console.error(`Failed to parse server response with the following error: ${error}`);
      }
      return parsedResponse;
    },
  },
};

// game mixin object (shared between ResumingGame and Game components)
export const GameMixin = {
  watch: {
    stompClient: {
      handler() {
        console.log('change to stompclient!');
        // eslint-disable-next-line
        console.log('connected: ' + this.stompClient.connected);
        if (!this.stompClient.connected && !this.isResume) this.stompFailure('lock screen error');
      },
      deep: true,
    },
  },
  data() {
    return {
      playerAnswered: false,
      bothPlayersAnswered: false,
    };
  },
  methods: {
    ...mapMutations('game', [
      'setUserLeveledUp',
      'setPlayersPostGameData',
      'updatePrizePostGameData',
    ]),
    ...mapMutations('common', [
      'storeUserLevel',
      'storeUserAvailableCoins',
    ]),
    setPrizePostGameData(responseData) {
      this.updatePrizePostGameData({
        winDTO: responseData.prizeWonDTO,
        lostDTOs: responseData.prizesNotWonDTO,
      });
    },
    storeTIPostGameData(responseData) {
      // responseData.id
      console.log(responseData);
      this.setUserLeveledUp(responseData.postGameData.levelUp);
      if (responseData.postGameData.levelUp) {
        this.storeUserLevel(responseData.postGameData.currentLevel);
      }
      if (this.userDetails) { // is Authorized user or not
        this.storeUserAvailableCoins({ availableCoins: responseData.postGameData.currentAvailableCoins });
      }
      this.setPlayersPostGameData({
        postgamePointsFromCorrectAnswers: responseData.postGameData.postgamePointsFromCorrectAnswers,
        postgamePointsFromRoundsWon: responseData.postGameData.postgamePointsFromRoundsWon,
        postgamePointsFromGameWon: responseData.postGameData.postgamePointsFromGameWon,
        postgamePointsTotal: responseData.postGameData.postgamePointsTotal,
        levelUp: responseData.postGameData.levelUp,
        levelUpPoints: responseData.postGameData.levelUpPoints,
        levelUpGames: responseData.postGameData.levelUpGames,
        currentLevel: responseData.postGameData.currentLevel,
        gamesToNextLevel: responseData.postGameData.gamesToNextLevel,
        currentLevelGamesWon: responseData.postGameData.currentLevelGamesWon,
      });
    },
  },
  computed: {
    ...mapState('common', [
      'userDetails',
    ]),
    ...mapState('game', [
      'playersDetails',
    ]),
  },
};

// game mixin object 2 (shared between all game components and is used for flow control,
// when we press the back or forward browser buttons or refresh the page)
export const GameMixin2 = {
  data() {
    return {
      normalTransition: false,
    };
  },
  methods: {
    ...mapMutations('game', [
      'setTransitionOnlyForSearchingToOpponent',
    ]),
  },
  beforeRouteEnter(to, from, next) {
    console.log('==> inside component\'s beforeRouteEnter:');
    console.log(`from.path: ${from.path}`);
    console.log(`to.path: ${to.path}`);
    // the page have must been refreshed, redirect to home page
    if (from.path === '/') {
      next({ path: '/home' });
    }
    next();
  },
  beforeRouteLeave(to, from, next) {
    console.log('==> inside component\'s beforeRouteLeave:');
    console.log(`from.path: ${from.path}`);
    console.log(`to.path: ${to.path}`);
    console.log('this.normalTransition:');
    console.log(this.normalTransition);
    if (this.transitionOnlyForSearchingToOpponent && (from.path === '/searchingOpponent' && to.path === '/opponentFound')) {
      console.log('User tries again for the same Game to play a game, so navigate him to Opponent Found and not HOME');
      this.normalTransition = true;
      this.setTransitionOnlyForSearchingToOpponent(false);
      next();
    }
    if (!this.normalTransition) {
      this.normalTransition = true;
      console.log('going to home');
      next({ path: '/home' });
    }
    next();
  },
  computed: {
    ...mapState('game', [
      'transitionOnlyForSearchingToOpponent',
    ]),
  },
};

export const GameMixin3 = {
  beforeDestroy() {
    console.log(`in ${this.$options.name} beforeDestroy hook`);
    console.log('this.subscription', this.subscription);
    // if for any reason we leave this component earlier from the websocket's response,
    // unsubscribe from the subscribed channel
    this.subscription.unsubscribe();
    if (this.timer !== undefined || this.timer !== null) {
      clearInterval(this.timer);
      this.stopTimer();
    }
  },
};

export const GameMixin4 = {
  data() {
    return {
      normalTransition: false,
    };
  },
  methods: {
    ...mapMutations('game', [
      'updateUnauthorizedWinnerInfo',
    ]),
    saveUnauthorizedMsisdnAndPrizeIdToCallLSC() {
      this.updateUnauthorizedWinnerInfo();
    },
  },
  beforeRouteLeave(to, from, next) {
    if (!this.normalTransition) {
      console.log('going to visitor');
      this.normalTransition = true;
      this.subscription.unsubscribe();
      this.stompClient.disconnect();
      next({ path: '/' });
    }
    next();
  },
};



// WEBPACK FOOTER //
// ./src/common/mixins/game.js